import { useEffect, useState } from "react"
import { hash } from "src/config";
import { useConfiguration } from "src/hooks/Configuration";
import { useLanguage } from "src/hooks/Language";
import { dateLanguageDate, dateLanguageTime, dateSimpleEN, day } from "src/utils/date";
import { loadFromJson } from "src/utils/loadFromJson";
function incluiIgnorandoAcentos(texto, termo) {
  const normalizar = str => str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
  return normalizar(texto).includes(normalizar(termo));
}
export default function useProgramHook({configs}){

    const {configuration } = useConfiguration();
    const {language, translateProperty} = useLanguage();
    const [data, setData] = useState<Array<any>>([]);

    const [searchProps, setSearchProps] = useState<Array<Record<string,any>>>([]);
    const [categoriesFilter, setCategoriesFilter] = useState([]);
    const [roomsFilter, setRoomsFilter] = useState([]);
    const [speakersFilter, setSpeakersFilter] = useState<Record<string,any>[]>([]);



const [filter, setFilter ] = useState<Record<string,any>>({
  search : '',
  category : '',
  room_name : '',
  day: '',
  speakers: ''
});

    const changeFilter = ( property, value) => {

      setFilter( state => ({
        ...state,

         [property] :value 


      }))

    }

   const applyFilter = (content) => {
  let contentData = content?.length > 0 ? [...content] : [];

   

  if (contentData?.length > 0) {
    contentData = contentData.reduce((acc, item) => {
      if (!item?.programs?.length) return acc;

      let program = [...item.programs];

  if (filter?.category) {
        program = program.filter(i =>{ 
 
        return  i?.categories?.filter(a => a?.title === filter?.category)?.length > 0
        
        
        }
        );
      }
      if (filter?.room_name) {
        program = program.filter(i => i?.room_title === filter?.room_name);
      }
      if (filter?.day) {
        program = program.filter(i => i?.day === filter?.day);
      }

      
      if (filter?.speakers) {
        program = program.filter(i =>{ 
 
        return  i?.speakers?.filter(a => a?.name === filter?.speakers)?.length > 0
        
        
        }
        );
      }
      if (filter?.search) {
        program = program.filter(i => {
     
          const concat = language === 'en' ? `${i?.speakersConcat}${i?.title_en || ''}${i?.category_title_en || ''}${i?.description_en || ''}${i?.room_title_en || ''}` : language === 'es' ? `${i?.speakersConcat}${i?.title_es || ''}${i?.category_title_es || ''}${i?.description_es || ''}${i?.room_title_es || ''}` : `${i?.speakersConcat}${i?.title || ''}${i?.category_title || ''}${i?.description || ''}${i?.room_title || ''}`;
          return incluiIgnorandoAcentos(concat, filter?.search);
        });
      }

      if (program.length > 0) {
        acc.push({ ...item, programs: program });
      }

      return acc;
    }, []);
  }

  return contentData;
};

    const processContent = ({ program : content, rooms, categories}) => {


      const categoriesKeys = {};

      categories?.map( category => {

        categoriesKeys[category?._id?.toString()] = category;

      })

      const roomKeys = {};

      rooms?.map( room => {

        roomKeys[room?._id?.toString()] = room;

      })

      const keys = {
        category : {},
        room_name : {},
        speakers : {},
        day : {}
      }

      content?.sort((a,b) => (a?.date || a?.start_hour) < (b?.date || b?.start_hour) ? -1 : (a?.date || a?.start_hour) > (b?.date || b?.start_hour) ? 1 : 0)
      
      const list : Array<any> = [];
  
      content?.map( program => {
 
          const dayName = program?.start_hour ? dateSimpleEN(program.start_hour) : '';

          const index = list?.findIndex( i => i?.day === dayName);


          let speakersConcat = ``;

          program?.speakers?.map( i => {
speakersConcat = `${speakersConcat}${i?.name}`;

          })

     

          const categoriesInfo : Record<string,any> = [];
          const mainCategory = program?.category_id || program?.categories?.[0]?._id ? categories?.find( cat => cat?._id ===  (program?.category_id ? program?.category_id : program?.categories?.[0]?._id) ) : false;

          program?.categories?.map( (i, index) => {

            const category = categories?.find( cat => cat?._id === i?._id )

            if(category){
            categoriesInfo.push(category)
            }
 

          })


          const item = {...program,
            day: dayName,
            date_start: dateLanguageDate(program?.start_hour,'ptBr'),
            date_start_en: dateLanguageDate(program?.start_hour,'en'),
            date_start_es: dateLanguageDate(program?.start_hour,'es'),
            date_end: dateLanguageDate(program?.end_hour,'ptBr'),
            date_end_en: dateLanguageDate(program?.end_hour,'en'),
            date_end_es: dateLanguageDate(program?.end_hour,'es'),


            hour_start: dateLanguageTime(program?.start_hour,'ptBr'),
            hour_start_en: dateLanguageTime(program?.start_hour,'en'),
            hour_start_es: dateLanguageTime(program?.start_hour,'es'),
            hour_end: dateLanguageTime(program?.end_hour,'ptBr'),
            hour_end_en: dateLanguageTime(program?.end_hour,'en'),
            hour_end_es: dateLanguageTime(program?.end_hour,'es'),

            category_image : program?.category_name_id ? categoriesKeys?.[program?.category_name_id]?.image ? categoriesKeys?.[program?.category_name_id]?.image : '' : '',
            category_title : program?.category_name_id ? categoriesKeys?.[program?.category_name_id]?.title ? categoriesKeys?.[program?.category_name_id]?.title : '' : '',
   category_title_en : program?.category_name_id ? categoriesKeys?.[program?.category_name_id]?.title_en ? categoriesKeys?.[program?.category_name_id]?.title_en : '' : '',
   category_title_es : program?.category_name_id ? categoriesKeys?.[program?.category_name_id]?.title_es ? categoriesKeys?.[program?.category_name_id]?.title_es : '' : '',
   
      category_description : program?.category_name_id ? categoriesKeys?.[program?.category_name_id]?.description ? categoriesKeys?.[program?.category_name_id]?.description : '' : '',
     
    category_description_en : program?.category_name_id ? categoriesKeys?.[program?.category_name_id]?.description_en ? categoriesKeys?.[program?.category_name_id]?.description_en : '' : '',
     
   category_description_es : program?.category_name_id ? categoriesKeys?.[program?.category_name_id]?.description_es ? categoriesKeys?.[program?.category_name_id]?.description_es : '' : '',
     category_background : mainCategory?.background || '',
      category_color : mainCategory?.color || '',
           category_border : program?.category_name_id ? categoriesKeys?.[program?.category_name_id]?.border ? categoriesKeys?.[program?.category_name_id]?.border : '' : '',
              room_border : program?.room_name_id ? roomKeys?.[program?.room_name_id]?.border ? roomKeys?.[program?.room_name_id]?.border : '' : '',
           
              room_image : program?.room_name_id ? roomKeys?.[program?.room_name_id]?.image ? roomKeys?.[program?.room_name_id]?.image : '' : '',
            room_title : program?.room_name_id ? roomKeys?.[program?.room_name_id]?.title ? roomKeys?.[program?.room_name_id]?.title : '' : '',
   room_title_en : program?.room_name_id ? roomKeys?.[program?.room_name_id]?.title_en ? roomKeys?.[program?.room_name_id]?.title_en : '' : '',
   room_title_es : program?.room_name_id ? roomKeys?.[program?.room_name_id]?.title_es ? roomKeys?.[program?.room_name_id]?.title_es : '' : '',
   
      room_description : program?.room_name_id ? roomKeys?.[program?.room_name_id]?.description ? roomKeys?.[program?.room_name_id]?.description : '' : '',
     
    room_description_en : program?.room_name_id ? roomKeys?.[program?.room_name_id]?.description_en ? roomKeys?.[program?.room_name_id]?.description_en : '' : '',
     
   room_description_es : program?.room_name_id ? roomKeys?.[program?.room_name_id]?.description_es ? roomKeys?.[program?.room_name_id]?.description_es : '' : '',
     room_background : program?.room_name_id ? roomKeys?.[program?.room_name_id]?.background ? roomKeys?.[program?.room_name_id]?.background : '' : '',
         room_color : program?.room_name_id ? roomKeys?.[program?.room_name_id]?.color ? roomKeys?.[program?.room_name_id]?.color : '' : '',
             speakersConcat : speakersConcat,


             categories : categoriesInfo,
             main_category: mainCategory
  



  }

          if(index < 0){
            list.push({
              day: dayName,
              title: dateLanguageDate(program?.start_hour,'ptBr'),
              title_en: dateLanguageDate(program?.start_hour,'en'),
              title_es: dateLanguageDate(program?.start_hour,'es'),
              programs :[ item ]
            })
          }
          else{
            list[index].programs.push(item);
          }

    


      })


   
      

    

      setData(list);
      return list;

    }

 


    const filteredData : Array<Record<string,any>> = applyFilter(data);






 const processSpeakers = ( speakers) => {



  const list : Record<string,any>[] = [];

  speakers?.map( group => {

    group?.speakers?.map( speakerItem => {

      const index = list?.findIndex( i => i?._id === speakerItem?._id);

      if(index < 0){
        list.push( speakerItem)
      }


    })

  })

  list.sort((a,b) => {
  
    const aName = a?.name?.trim()?.toLowerCase();
    const bName = a?.name?.trim()?.toLowerCase();

    return aName < bName ? -1 : aName > bName ? 1 : 0
  
  })

  return list;


 }
 
 

    const loadProgram = async () => {

let [program, rooms = [], categories = [], speakers = []] = await Promise.all([
loadFromJson({ hash: hash, project_id: configuration?.url, table: configs?.useParalel === 'Sim' ? 'ProgramExtra' : 'Program' }),
loadFromJson({ hash: hash, project_id: configuration?.url, table: configs?.useParalel === 'Sim' ? 'ProgramExtraRoom' : 'ProgramRoom'  }),
loadFromJson({ hash: hash, project_id: configuration?.url, table: configs?.useParalel === 'Sim' ? 'ProgramExtraCategory' : 'ProgramCategory' }),
loadFromJson({ hash: hash, project_id: configuration?.url, table: 'SpeakerPosition' }),
])

 program = program || [];
 rooms = rooms || [];
 categories = categories || [];
 speakers = speakers || [];

const list = processContent({program, rooms, categories})


const searchPropsInfo : Array<Record<string,any>> =[];
const speakersList = processSpeakers( speakers);

    const days = list?.reduce( (prev, item) => {
      prev.push( {label: translateProperty({item, property: 'title', language}), value: item?.day})
      return prev;
    },[])?.sort((a,b) => a?.label < b?.label ? -1 : a?.label > b?.label ? 1 : 0)

    const categoriesItems = categories?.reduce( (prev, item: Record<string,any>) => {
      prev.push( {label: translateProperty({item, property: 'title', language}), value: item?.title})
      return prev;
    },[] as Record<string,any>[])?.sort((a,b) => a?.label < b?.label ? -1 : a?.label > b?.label ? 1 : 0)

    
        const roomsItems = rooms?.reduce( (prev, item : Record<string,any>) => {
      prev.push( {label: translateProperty({item, property: 'title', language}), value: item?.title})
      return prev;
    },[]as Record<string,any>[])?.sort((a,b) => a?.label < b?.label ? -1 : a?.label > b?.label ? 1 : 0)

            const speakersItems = speakersList?.reduce( (prev : Record<string,any>[], item : Record<string,any>) => {
      prev.push( {label: item?.name, value: item?.name})
      return prev;
    },[]as Record<string,any>[])?.sort((a,b) => a?.label < b?.label ? -1 : a?.label > b?.label ? 1 : 0)


 if(configs?.search_date === 'Sim'){
  searchPropsInfo.push({ 
        type: 'select',
        list : days,
        name: 'day',
        titles: {
            title: configs?.search_date_title || 'Dia',
            title_en: configs?.search_date_title_en || 'Day',
            title_es: configs?.search_date_title_es || 'Día',
        }
      } )
 }

  if(configs?.search_room === 'Sim'){
  searchPropsInfo.push( { 
        type: 'select',
        list : roomsItems,
        name: 'room_name',
        titles: {
            title: configs?.search_room_title || 'Palco',
            title_en: configs?.search_room_title_en || 'Stage',
            title_es: configs?.search_room_title_es || 'Escenario',
        }
      } )
 }

   if(configs?.search_categories === 'Sim'){
  searchPropsInfo.push(  { 
        type: 'select',
        list : categoriesItems,
        name: 'category',
        titles: {
            title: configs?.search_categories_title || 'Categoria',
      title_en: configs?.search_categories_title_en || 'Category',
      title_es: configs?.search_categories_title_es || 'Categoría',
        }
      } )
 }
 
   if(configs?.search_speakers === 'Sim'){
  searchPropsInfo.push(    { 
        type: 'select',
        list : speakersItems,
        name: 'speakers',
        titles: {
                  title: configs?.search_speakers_title || 'Palestrantes',
     title_en: configs?.search_speakers_title_en || 'Speakers',
      title_es: configs?.search_speakers_title_es || 'Conferencistas',
        }
      } )
 }


    if(configs?.search_button === 'Sim'){
  searchPropsInfo.push(     { 
        type: 'search',
   
        name: 'search',
        titles: {
                    title: configs?.search_buttton_title || 'Pesquisar',
     title_en: configs?.search_buttton_title_en || 'Search',
      title_es: configs?.search_buttton_title_es || '	Buscar',
        }
      } )
 }
 






setCategoriesFilter(categories)
setRoomsFilter(rooms)
setSpeakersFilter(speakersList)
setSearchProps(searchPropsInfo)


    }

    return {
      filter,
        filteredData,
        loadProgram,
        changeFilter,
  
    
        searchProps,

    }
}